!function($) {
  try {
    var faqAccordion = {
      init: function(){
        var flg = 0;
        var $faqHeading = $('.faq button.faq__question');
        //$('.faqAccordion > dd').attr('aria-hidden',true);
        //$faqHeading.attr('aria-expanded',false);
        $('body').on('click activate', '.faq button.faq__question', function(){
          if( flg ) return false;
          flg = 1;
          var state = $(this).attr('aria-expanded') === 'false' ? true : false;
          $(this).attr('aria-expanded',state);
          $(this).next().slideToggle(function(){
            flg = 0;
          });
            $(this).next().attr('aria-hidden',!state);
          return false;
        });

        $faqHeading.on('keydown',function(event){
          var keyCode = event.keyCode || e.which;
          if (keyCode === 13){
            $(this).trigger('activate');
          }
        });
      }
    }
    } catch (error){
  }

  function listenForBoldApp () {
    if (document.querySelector('.shappify_qb_grid')) {
        //setTimeout(addUnitePriceToDiscounts,800);
        setTimeout(addUnitePriceToDiscounts,1000);
        console.log('addUnitePriceToDiscounts');
    }
    MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    var observer = new MutationObserver(function(mutations, observer) {


        // fired when a mutation occurs
        for (var i = 0; i < mutations.length; i++) {
            console.log(mutations[i]);
            if (mutations[i].target.classList.contains('shappify-qty-msg') && mutations[i].removedNodes.length == 0) {
                console.log(mutations[i]);
                addUnitePriceToDiscounts();
                console.log('addUnitePriceToDiscounts');
            } else {
               //console.log(mutations[i].target);
            }

        }
    });

    // define what element should be observed by the observer
    // and what types of mutations trigger the callback
    var docContainer = document.querySelector('form[action="/cart/add"]');
    observer.observe(docContainer, {
        subtree: true,
        attributes: false,
        childList: true
        //...
    });
  }




  function addUnitePriceToDiscounts () {
    var tableHeader = document.querySelector('form .shappify_qb_grid thead tr')
    var tablePrices = document.querySelectorAll('form .shappify_qb_grid tbody tr td:nth-child(2)');
    var tablePricesRow = document.querySelectorAll('form .shappify_qb_grid tbody tr');
    var $currUnitPrice = document.querySelector('[data-unit-price-amount]');
    var $currUnitMeasure = document.querySelector('[data-unit-price-measure]');

    function rmBoldExtraTable () {
      var boldT = document.querySelector('body > div > .shappify_qb_grid');
      if (boldT) {
        boldT.parentNode.removeChild(boldT);
      }
    }

    if ($currUnitPrice) {
      addUnitePriceTable();
      addUnitePriceTableItems();
      //debugger;
      setTimeout(function(){

        addUdiscountPercTable();
        addItemsUdiscountPerc();
      },10)

    }

    function getNumericPrice (price) {
      return price.match(/\d+/g).join('')*0.01;
    }

    function getDiscountPerc (priceBefore, priceAfter) {
        return ((priceAfter/priceBefore)).toFixed(2);
    };

    function addUnitePriceTable () {
      $(tableHeader).append('<th>Grundpreis</th>');
      var unitePriceMeasure = '<td>' + $currUnitPrice.innerHTML + '/' + $currUnitMeasure.innerHTML + '</td>';
      $(unitePriceMeasure).insertAfter( $(tablePrices[0]) );
    };

    function addUnitePriceTableItems () {
      var originalItemPrice = getNumericPrice(tablePrices[0].innerHTML);
      var originalUnitePrice = getNumericPrice($currUnitPrice.innerHTML);
      for (var i = 1; i < tablePrices.length; i++) {
        //debugger;
        var discountPrice = getNumericPrice(tablePrices[i].innerHTML)
        var discPerc = getDiscountPerc( originalItemPrice , discountPrice );

        var thisUnitePrice = Shopify.formatMoney((originalUnitePrice*100)*discPerc,"€{{amount_with_comma_separator}}")

        var unitePriceMeasure = '<td>' + thisUnitePrice + '/' + $currUnitMeasure.innerHTML + '</td>';
        //$(unitePriceMeasure).insertAfter( $(tablePrices[i]) );
        $(tablePricesRow[i]).append($(unitePriceMeasure))
      }
    };

    function addUdiscountPercTable () {
      $(tableHeader).append('<th>Ersparnis</th>');
      $(tablePricesRow[0]).append('<td> </td>')
    };

    function addItemsUdiscountPerc () {
      var originalItemPrice = getNumericPrice(tablePrices[0].innerHTML);
      var originalUnitePrice = getNumericPrice($currUnitPrice.innerHTML);
      for (var i = 1; i < tablePrices.length; i++) {
        //debugger;
        var discountPrice = getNumericPrice(tablePrices[i].innerHTML)
        var discPerc = getDiscountPerc( originalItemPrice , discountPrice );
        var unitedoscountPerc = '<td>' + ((1-discPerc)*100).toFixed(0) + '%</td>';
        //$(unitedoscountPerc).insertAfter( $(tablePrices[i]) );
        $(tablePricesRow[i]).append($(unitedoscountPerc))
      }
    };

  };


  $(document).ready(function() {
  	faqAccordion.init();
    if (window.location.href.indexOf('/product') > 0) {
      listenForBoldApp()
    }
  })




}(jQuery);


// document.addEventListener('variant:changed', function(event) {
//   var variant = event.detail.variant; // Gives you access to the whole variant details
//   console.log("variant is changed");
//   var price = variant.price;
//   console.log("variant price", price);
//   var comparePrice = variant.compare_at_price;
//   console.log("variant compare price", comparePrice);

//   var quickShop = $('.modal--quickshop-full')[0];
//   if(quickShop != null){
//     var priceClass = quickShop.querySelector('.product--price');
//     var compareClass = priceClass.querySelector('[data-price-compare-at] .money');
//     var priceSet = priceClass.querySelector('[data-price] .money');
//     if(compareClass != null){
//       compareClass.innerText = comparePrice;
//     }
//     if(priceSet !=null){
//       priceSet.innerText = price;
//     }
//   }




// });
